// src/pages/PrivacyPolicy.js
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>

      <p>
        At WePrint PhotoBooks, your privacy is important to us. This Privacy Policy outlines how
        we collect, use, and safeguard your personal information when you use our website and services.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Personal details such as your name, email, phone number, and address.</li>
        <li>Photographs or files uploaded for photobook creation.</li>
        <li>Transaction and payment information.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To process and fulfill your orders.</li>
        <li>To provide customer support and updates.</li>
        <li>To improve our products and services.</li>
        <li>To send you promotional emails (only if you've opted in).</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>
        We do not sell or share your personal data with third parties unless required by law or
        necessary to complete your service (e.g., courier services).
      </p>

      <h2>4. Data Security</h2>
      <p>
        We use appropriate technical and organizational measures to protect your data from unauthorized
        access, loss, or misuse.
      </p>

      <h2>5. Your Rights</h2>
      <ul>
        <li>You can request to access, correct, or delete your personal data.</li>
        <li>You can unsubscribe from promotional messages anytime.</li>
      </ul>

      <h2>6. Contact Us</h2>
      <p>
        If you have any questions regarding our Privacy Policy, please contact:
      </p>
      <ul>
        <li>Email: <a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a></li>
        <li>Phone: <a href="tel:+918861494444">+91 88614 94444</a></li>
      </ul>
    </div>
  );
}
